<h2 mat-dialog-title>
  <div class="dialog-header">
    <span> Configure {{ data.type | questionTypeName }} </span>

    <button mat-stroked-button type="button" (click)="onChangeQuestionType()">
      Change Question Type
    </button>
  </div>
</h2>

<mat-dialog-content>
  <div class="configuration-step">
    <div class="main-layout-wrapper">
      <section class="content-area">
        <app-column-configuration-element-settings
          [elementId]="data.element_id"
        ></app-column-configuration-element-settings>
      </section>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()">Cancel</button>
  <button mat-stroked-button class="primary-btn" (click)="onFinish()">
    Finish
  </button>
</mat-dialog-actions>
